import { useEffect } from 'react';
import {
  shallowEqual,
  useSelector,
  useDispatch,
} from 'react-redux';

import {
  coreActions,
  coreSelectors,
} from '@gymcloud/core';
import { RootState } from 'web-types';

import * as S from './styled';

const mapState = (state: RootState) => ({
  masterPro: coreSelectors.getProfile('master_pro')(state),
});

const MasterPro = () => {
  const { masterPro } = useSelector(mapState, shallowEqual);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      coreActions.requestMasterPro(),
    );
  }, [])

  const activePercentage = masterPro.total_users === 0
    ? 0
    : Math.round((masterPro.active_subscriptions_count / masterPro.total_users) * 100)

  const radius = 108;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (activePercentage / 100) * circumference;

  return (
    <S.DashboardContainer>
      <S.TopSection>
        <S.MetricCard>
          <S.MetricLabel>Active<br />Subscriptions</S.MetricLabel>
          <S.MetricValue>{masterPro.active_subscriptions_count}</S.MetricValue>
        </S.MetricCard>

        <S.ChartContainer>
          <S.CircleChart>
            <S.CircleSvg width="280" height="280">
              <S.CircleBackground
                cx="140"
                cy="140"
                r={radius}
              />
              <S.CircleProgress
                cx="140"
                cy="140"
                r={radius}
                strokeDasharray={circumference}
                strokeDashoffset={offset}
              />
            </S.CircleSvg>
            <S.ChartText>
              <S.PercentageValue>{activePercentage}%</S.PercentageValue>
              <S.PercentageLabel>% Active Subs/Total</S.PercentageLabel>
            </S.ChartText>
          </S.CircleChart>
        </S.ChartContainer>

        <S.NewSubscriptionsCard>
          <S.MetricLabel>New Active<br />Subscriptions</S.MetricLabel>
          <S.SubMetric>
            <S.SubLabel>This Month</S.SubLabel>
            <S.SubValue className="primary">{masterPro.new_subscriptions_count}</S.SubValue>
          </S.SubMetric>
          <S.SubMetric>
            <S.SubLabel>Last Month</S.SubLabel>
            <S.SubValue>{masterPro.last_month_active_subscriptions_count}</S.SubValue>
          </S.SubMetric>
        </S.NewSubscriptionsCard>
      </S.TopSection>

      <S.BottomSection>
        <S.StatCard>
          <S.StatLabel>Total Users</S.StatLabel>
          <S.StatValue>{masterPro.total_users}</S.StatValue>
        </S.StatCard>

        <S.StatCard>
          <S.StatLabel>Freemium Users</S.StatLabel>
          <S.StatValue>{masterPro.freemium_users}</S.StatValue>
        </S.StatCard>

        <S.StatCard>
          <S.StatLabel>Users in Trial</S.StatLabel>
          <S.StatValue>{masterPro.users_in_trial}</S.StatValue>
        </S.StatCard>
      </S.BottomSection>
    </S.DashboardContainer>
  );
};

export default MasterPro;
